import { Container, ContainerGutter, ContainerPadding, Divider, Spinner } from '@volkswagen-onehub/components-core';
import React from 'react';
import { getLang, getTranslations } from '../../../../translations';
import { formatCurrency } from '../../../../utils/format';
import { getEVIncentives } from '../../../../utils/get-ev-incentives';
import { CardetailsInterface } from '../../../CarDetails';
import BuildPriceFieldset from '../../BuildPriceFieldset';
import Estimates from '../Estimates';
import AccessoryPackage from '../options/AdditionalOptions/AccessoryPackage';
import AdditionalDetails from '../options/AdditionalOptions/AdditionalDetails';
import GovernmentRebates from '../options/AdditionalOptions/GovernmentRebates';
import PriceDetails from '../PriceDetails';

interface TotalPriceInterface extends CardetailsInterface { }

export default ({ vehicle } : TotalPriceInterface) => {
    const lang = getLang();

    const pcs = vehicle.pcs[lang];

    const trans = getTranslations();

    const incentives = getEVIncentives(vehicle);

    return pcs && vehicle ?
            <BuildPriceFieldset legend={trans.details.summary.process} headline={trans.details.summary.price}>
                <Container wrap="always"
                    gutter={ContainerGutter.static150} padding={ContainerPadding.static0}>
                    <PriceDetails name={trans.details.summary.msrp} price={formatCurrency(vehicle?.price, true, lang)} />
                    {vehicle?.color_interior &&
                        <PriceDetails isColor={true}
                            colorLabel={trans.labels.interior_short}
                            color={vehicle?.color_interior.label && vehicle?.color_interior.label[lang] as string}
                            price="" />}
                    {vehicle?.color_exterior &&
                        <PriceDetails isColor={true}
                            colorLabel={trans.labels.exterior_short}
                            color={vehicle?.color_exterior.label && vehicle?.color_exterior.label[lang]}
                            price="" />}

                    {vehicle.options && <AccessoryPackage options={vehicle.options} />}

                    <Divider />

                    <PriceDetails
                        name={pcs?.additional_prices.build_price.label}
                        price={formatCurrency(Number(pcs.additional_prices.build_price.value), true, lang)} />

                    {
                      pcs.additional_prices
                      ? <>
                        <AdditionalDetails fees={pcs.additional_prices} />
                      </>
                      : null
                    }

                    {
                      incentives.count
                      ? <GovernmentRebates fees={pcs.additional_prices} />
                      : null
                    }

                    <Divider />

                    <PriceDetails name={trans.details.summary.total} price={formatCurrency(Number(pcs?.price.value), true, lang)} />

                    <Divider />

                    <Estimates />
                </Container>
            </BuildPriceFieldset> : <Spinner />;
}
